export enum WebSocketActionTypes {
  CONNECT = "WEBSOCKET/CONNECT",
  CONNECTED = "WEBSOCKET/CONNECTED",
  DISCONNECT = "WEBSOCKET/DISCONNECT",
  DISCONNECTED = "WEBSOCKET/DISCONNECTED",
  MESSAGE = "WEBSOCKET/MESSAGE",
  SEND = "WEBSOCKET/SEND",
  ERROR = "WEBSOCKET/ERROR",
}
